/* HTML */
<template>
	<div class="table-item-box padding-l-none">
		<section style="height: 100%;">
			<!--查询工具条-->
			<el-col style="padding-bottom: 0px;text-align: left;height: 52px;">
				<el-form :inline="true" :model="filters" ref="filters">
					<el-form-item>查询条件：</el-form-item>
					<el-form-item v-if="false" prop="projectId" style="display: none;">
						<el-select v-model="filters.projectId" placeholder="请选择项目" clearable @change="researchGpsTag">
							<el-option v-for="(value,key) in projectInfos" :key="key" :label="value.projectName" :value="key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="type" style="width: 150px;display: none;">
						<el-select v-model="filters.type" placeholder="请选择设备类型" clearable @change="researchGpsTag">
							<el-option v-for="(value,key) in types" :key="key" :label="value" :value="key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="status" style="width: 150px;">
						<el-select v-model="filters.status" placeholder="请选择设备状态" clearable @change="researchGpsTag">
							<el-option v-for="(value,key) in status" :key="key" :label="value" :value="key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="bindType" style="width: 150px;">
						<el-select v-model="filters.bindType" placeholder="请选择绑定状态" clearable @change="researchGpsTag">
							<el-option v-for="(value,key) in bindTypes" :key="key" :label="value" :value="key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="$store.getters.getUserRoleId == '1'" prop="allocateType" style="width: 150px;">
						<el-select v-model="filters.allocateType" placeholder="请选择分配状态" clearable @change="researchGpsTag">
							<el-option v-for="(value,key) in allocateTypes" :key="key" :label="value" :value="key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="$store.getters.getUserRoleId == '1' && filters.allocateType == '1'" prop="accountKey" style="width: 180px;">
						<el-select v-model="filters.accountKey" placeholder="请选择账户" @change="researchGpsTag">
							<el-option v-for="(value,key) in accountManagerInfos" :key="key" :label="value.account" :value="key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="simExpirationTime" style="display: none;">
						<el-date-picker v-model="filters.simExpirationTime" type="date" value-format="yyyy-MM-dd" placeholder="选择流量过期日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item prop="keyword">
						<el-input v-model="filters.keyword" placeholder="请输入设备编号/SIM卡号" clearable @keyup.enter.native="researchGpsTag" :style="{width: '220px'}">
							<i slot="suffix" class="el-input__icon el-icon-search" @click="researchGpsTag"></i>
						</el-input>
					</el-form-item>
					<el-form-item style="position: absolute;top: 9px;right: 10px;z-index: 3;margin: 0;">
						<!--						<el-button type="primary" size="mini" trigger="click" @click="addNotice"><i class="el-icon-circle-plus-outline" /> 新增消息</el-button>-->
						<el-button type="primary" size="mini" trigger="click" @click="updateSim"><i class="el-icon-refresh" /> 更新流量卡</el-button>
						<el-button type="primary" size="mini" trigger="click" @click="add"><i class="el-icon-circle-plus-outline" v-if="$store.getters.getUserRoleId == '1'" /> 分配标签</el-button>
						<template>
							<el-dropdown split-button type="primary" @click="deleteRows" trigger="click" size="mini">
								<i class="el-icon-delete"></i> 批量回收
								<el-dropdown-menu slot="dropdown" trigger="click">
									<el-dropdown-item icon="el-icon-delete" @click.native="completelyDelete">批量删除</el-dropdown-item>
									<el-dropdown-item icon="el-icon-download" @click.native="searchExportData">批量导出</el-dropdown-item>
									<el-dropdown-item>
										<el-upload accept=".xlsx,.xls" :auto-upload="true" :show-file-list="false" :before-upload="beforeUpload" :on-success="uploadGpsTagIdSuccess" :on-error="uploadError" :action="uploadGpsTagId.uploadUrl" :headers="uploadGpsTagId.myHeaders">
											<i class="el-icon-upload2"></i>批量上传
										</el-upload>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 表格 -->
			<el-table :data="tagInfos" @sort-change="changeSort" ref="multipleTable" stripe style="width: 100%;height: calc(100% - 96px);" @row-click="rowHandle" :class="{'table': true, 'no-pagination': false}">
				<el-table-column type="selection" :selectable="checkSelectable" />
				<el-table-column label="序号" type="index" width="60px">
					<template v-slot="scope">
						{{ scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column label="设备编号" width="150px" :sortable="filters.sortable" prop="did" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;cursor: pointer;text-decoration:underline;" :title="scope.row.did" @click="editRowConfig(scope.row, scope.$index)">
                            {{scope.row.did}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="流量卡号" min-width="180px" :sortable="filters.sortable" prop="iccid" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;cursor: pointer;text-decoration:underline;" :title="'iccid: ' + scope.row.iccid +
                              '\nimsi: ' + scope.row.imsi +
                              '\nimei: ' + scope.row.imei +
                              '\n套餐: ' + scope.row.simPackage +
                              '\n状态: ' + scope.row.simStatus +
                              '\n已用流量: ' + scope.row.simUsed + ' M' +
                              '\n激活时间: ' + scope.row.simActivationTime +
                              '\n过期时间: ' + $moment(scope.row.simExpirationTime).format('YYYY-MM-DD HH:mm:ss')" @click="searchSim(scope.row, scope.$index)" v-if="scope.row.iccid != null && scope.row.iccid != ''">
                            {{scope.row.iccid}}
                        </span>
						<span style="cursor: pointer;" class="el-icon-circle-plus-outline" type="text" size="mini" @click="()=>{addSim(scope.row, scope.$index)}" trigger="click" v-if="scope.row.iccid==null || scope.row.iccid == ''"> 添加</span>
					</template>
				</el-table-column>
				<!--				<el-table-column label="类型" min-width="100px" :sortable="filters.sortable" prop="did" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="scope.row.type">
                            {{types[scope.row.type]}}
                        </span>
					</template>
				</el-table-column>-->
				<el-table-column label="软件版本" min-width="80px">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="scope.row.versionSoft">{{scope.row.versionSoft}}</span>
					</template>
				</el-table-column>
				<el-table-column label="硬件版本" min-width="80px">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="scope.row.versionHard">{{scope.row.versionHard}}</span>
					</template>
				</el-table-column>
				<el-table-column label="电量" min-width="80px" :sortable="filters.sortable" prop="power" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="scope.row.power">{{scope.row.power + '%'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" min-width="80px" :sortable="filters.sortable" prop="status" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" v-if="scope.row.deviceStatus == null || scope.row.deviceStatus == ''">
                {{status[scope.row.status]}}
            </span>
						<span style="white-space: nowrap;cursor: pointer;text-decoration:underline;" :title="formatJsonForTitle(scope.row.deviceStatus)" v-else>
               {{status[scope.row.status]}}
            </span>
					</template>
				</el-table-column>
				<el-table-column label="更新时间" min-width="150px" :sortable="filters.sortable" prop="server_time" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="$moment(scope.row.uploadTime).format('YYYY-MM-DD HH:mm:ss')">{{$moment(scope.row.uploadTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
					</template>
				</el-table-column>
				<!--				<el-table-column v-if="false" label="所属项目" min-width="100px">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="projectInfos[scope.row.projectId]?projectInfos[scope.row.projectId].projectName:''">{{projectInfos[scope.row.projectId]?projectInfos[scope.row.projectId].projectName:''}}</span>
					</template>
				</el-table-column>-->
				<el-table-column v-if="$store.getters.getUserRoleId == '1'" label="所属账户" min-width="120px" :sortable="filters.sortable" prop="key" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="accountManagerInfos[scope.row.key]?accountManagerInfos[scope.row.key].account:''">{{accountManagerInfos[scope.row.key]?accountManagerInfos[scope.row.key].account:''}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120px">
					<template v-slot="scope">
						<span style="white-space: nowrap;cursor: pointer;text-decoration:underline;" :title="scope.row.did" @click="logDetail(scope.row, scope.$index)">
                            查看日志
                        </span>
					</template>
				</el-table-column>
			</el-table>

			<!--分页工具条-->
			<Pagination :currentPage="pagination.currentPage" :total="pagination.total" :pageSize="pagination.limit" @handleSizeChangeSub="handleSizeChangeSub" @handleCurrentChangeSub="handleCurrentChangeSub" />

			<!-- 分配标签 -->
			<GpsTagAddDialog ref="gpsTagAddDialog" :showSerialNumber="upload.showSerialNumber" :uploadUrl="uploadGpsTag.saveUrl" :projectInfos="projectInfos" :accountManagerInfos="accountManagerInfos" :previewTitle="upload.previewTitle" :previewData="upload.previewData" @research="researchGpsTag" />

			<!-- 标签配置 -->
			<GpsTagConfigDialog ref="gpsTagConfigDialog" @searchGpsTag="searchGpsTag" />

			<!-- 标签配置 -->
			<GpsTagLogTable ref="gpsTagLogTable" />

			<!-- 新增标签 上传 -->
			<GpsTagUploadDialog ref="gpsTagUploadDialog" :showSerialNumber="upload.showSerialNumber" :uploadUrl="upload.saveUrl" :projectInfos="projectInfos" :accountManagerInfos="accountManagerInfos" :previewTitle="upload.previewTitle" :previewData="upload.previewData" @research="researchGpsTag" />

			<!-- ======================= 导出所需数据 =============================== -->
			<el-table :data="exportDatas" id="out-table" stripe style="display: none;" class="table">
				<el-table-column label="GPS编号">
					<template v-slot="scope">
						{{ scope.row.did}}
					</template>
				</el-table-column>
				<el-table-column label="iccid">
					<template v-slot="scope">
						{{scope.row.iccid}}
					</template>
				</el-table-column>
				<el-table-column label="imei">
					<template v-slot="scope">
						{{scope.row.imei}}
					</template>
				</el-table-column>
				<el-table-column label="imsi">
					<template v-slot="scope">
						{{scope.row.imsi}}
					</template>
				</el-table-column>
				<el-table-column label="套餐">
					<template v-slot="scope">
						{{scope.row.simPackage}}
					</template>
				</el-table-column>
				<el-table-column label="套餐状态">
					<template v-slot="scope">
						{{scope.row.simStatus}}
					</template>
				</el-table-column>
				<el-table-column label="套餐使用">
					<template v-slot="scope">
						{{scope.row.simUsed}}
					</template>
				</el-table-column>
				<el-table-column label="激活时间">
					<template v-slot="scope">
						{{scope.row.simActivationTime}}
					</template>
				</el-table-column>
				<el-table-column label="过期时间">
					<template v-slot="scope">
						{{$moment(scope.row.simExpirationTime).format('YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="软件版本">
					<template v-slot="scope">
						{{scope.row.versionSoft}}
					</template>
				</el-table-column>
				<el-table-column label="硬件版本">
					<template v-slot="scope">
						{{scope.row.versionHard}}
					</template>
				</el-table-column>
				<!--                <el-table-column label="UWB序列号">
                    <template v-slot="scope">
                        {{scope.row.sid}}
                    </template>
                </el-table-column>-->
				<el-table-column label="电量">
					<template v-slot="scope">
						{{scope.row.power + '%'}}
					</template>
				</el-table-column>
				<el-table-column label="状态">
					<template v-slot="scope">
						{{status[scope.row.status]}}
					</template>
				</el-table-column>
				<el-table-column label="更新时间">
					<template v-slot="scope">
						{{$moment(scope.row.serverTime).format('YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column v-if="false" label="项目">
					<template v-slot="scope">
						{{projectInfos[scope.row.projectId]?projectInfos[scope.row.projectId].projectName:''}}
					</template>
				</el-table-column>
				<el-table-column v-if="$store.getters.getUserRoleId == '1'" label="所属账户">
					<template v-slot="scope">
						{{accountManagerInfos[scope.row.key]?accountManagerInfos[scope.row.key].account:''}}
					</template>
				</el-table-column>
				<el-table-column label="绑定名称">
					<template v-slot="scope">
						{{scope.row.bindName}}
					</template>
				</el-table-column>
				<el-table-column label="地址">
					<template v-slot="scope">
						{{scope.row.address}}
					</template>
				</el-table-column>
			</el-table>

		</section>

		<!-- 流量卡配置 -->
		<GpsTagSimConfigDialog ref="gpsTagSimConfigDialog" @searchGpsTag="searchGpsTag" />

		<!-- 流量卡配置 -->
		<GpsTagNoticeAddDialog ref="gpsTagNoticeAddDialog" @searchGpsTag="searchGpsTag" />

	</div>
</template>

<script>
	// 公共函数
	import GlobalFun from "@/global/global-function";
	// 公共 参数
	import GlobalParam from "@/global/global-param";
	// API GPS标签
	import ApiGpsTag from '@/request/api-gps-tag';
	// API 组织结构
	import ApiOrg from '@/request/api-org';
	// API 账户
	import ApiAccount from '@/request/api-account';
	// 弹框组件
	import GpsTagAddDialog from '@/components_outdoor/Device/GpsTagAddDialog';
	// 分页组件
	import Pagination from '@/components/Pagination'
	// gps上传组件
	import GpsTagUploadDialog from "./GpsTagUploadDialog";
	// gps配置组件
	import GpsTagConfigDialog from "./GpsTagConfigDialog";
	// gps日志
	import GpsTagLogTable from "./GpsTagLogTable";
	// 弹框组件
	import GpsTagSimConfigDialog from '@/components_outdoor/Device/GpsTagSimConfigDialog';
	import GpsTagNoticeAddDialog from '@/components_outdoor/Device/GpsTagNoticeAddDialog';
	export default {
		/**
		 * 组件名称
		 */
		name: "GpsTagTable",
		/**
		 * 组件引用
		 */
		components: {
			GpsTagConfigDialog,
			// 标签上传组件
			GpsTagUploadDialog,
			// 标签弹出层组件
			GpsTagAddDialog,
			// 分页工具
			Pagination,
			GpsTagLogTable,
			GpsTagSimConfigDialog,
			GpsTagNoticeAddDialog
		},
		/**
		 * @Des 数据接收
		 * @Auth 
		 * @Date 2025/09/20
		 */
		props: {
			/**
			 * @Des 管理员账户
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			accountManagerInfos: {
				type: Object,
				default: function() {
					return {}
				}
			},
		}, // props
		/**
		 * 数据定义
		 * @returns {{}}
		 */
		data() {
			return {
				/**
				 * @Des 查询条件属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				filters: {
					projectId: '',
					accountKey: '',
					key: '',
					keyword: '',
					status: '', // 1在线 2离线
					bindType: '', // 0未绑定 1绑定人 2绑定车
					allocateType: '', // 0未分配 1已分配
					type: '',
					orderBy: {
						'status': 'asc',
						"upload_time": "desc",
					},
					sortOrders: [
						"ascending",
						"descending"
					],
					sortable: 'custom',
					simExpirationTime: ''
				},
				// 基站集合
				tagInfos: [],
				exportDatas: [],
				projectInfos: {},
				locked: false,
				status: {
					1: '在线',
					2: '离线'
				},
				bindTypes: GlobalParam.bindTypes,
				allocateTypes: {
					0: '未分配',
					1: '已分配'
				},
				types: {
					'01': '电子护照',
					'02': '2A',
					'03': '蹄子',
					'05': '2G安全帽',
					'0E': '手牵手',
					'06': '测试定位标签',
					'0A': '定位标签',
					'0B': '室内外安全帽',
					'0C': '4G安全帽',
					'0F': '车载终端',
				},
				/**
				 * 分页数据
				 */
				pagination: {
					total: 0,
					startNum: 0,
					limit: 50,
					currentPage: 1
				},
				/**
				 * 上传属性
				 */
				upload: {
					previewTitle: [],
					previewData: [],
					saveUrl: '',
					showSerialNumber: true
				},

				/**
				 * 样式修改
				 *
				 */
				surroundSpan(value) {
					return '<span style="white-space: nowrap;" title="' + value + '">' + value + '</span>';
				},
				/**
				 * 上传配置
				 */
				uploadGpsTag: {
					myHeaders: {
						token: this.$store.state.token,
						lang: this.$store.state.lang,
						loginDevice: this.$store.state.loginDevice
					},
					saveUrl: ApiGpsTag.addGpsTagApi,
				},
				/**
				 * @Description 上传配置
				 * @Param
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				uploadGpsTagId: {
					myHeaders: {
						token: this.$store.state.token,
						lang: this.$store.state.lang,
						loginDevice: this.$store.state.loginDevice
					},
					uploadUrl: ApiGpsTag.batchUpdateGpsTagIdsApi,
					saveUrl: ApiGpsTag.addGpsTagIdApi
				},
				// 查询未加入项目的标签
				limit: 3000,
				
				// route params
				routeParams: {},
			}// return
		},// data
		computed: {},
		created() {
			// 查询登录账户的项目
			// this.searchAccountProject();
		},// created
		mounted() {
			this.routeParams = Object.assign({}, this.$route.params);
			this.filters.bindType = this.routeParams.bindType;
			
			// 查询标签
			this.searchGpsTag();
		},// mounted
		/**
		 * 方法定义
		 */
		methods: {
			formatJsonForTitle(jsonStr) {
				if(jsonStr == null || jsonStr == '') {
					return '';
				}
				try {
					const obj = JSON.parse(jsonStr);
					return JSON.stringify(obj, null, 2); // 完整格式化，用于title提示
				} catch(e) {
					return jsonStr || '';
				}
			},
			getFirstKeyValue() {
				const keys = Object.keys(this.accountManagerInfos);
				return keys.length > 0 ? keys[0] : "null";
			},
			/**
			 * 更新SIM卡信息
			 */
			updateSim() {
				let selection = this.$refs.multipleTable.selection;
				if(selection.length == 0) {
					this.$message({
						message: '请选择要更新的流量卡号',
						type: 'info',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}
				let iccids = [];
				selection.forEach((row, index) => {
					if(row.iccid != null && row.iccid != '') {
						iccids.push(row.iccid);
					}
				})
				if(iccids.length == 0) {
					this.$message({
						message: "请选择流量卡",
						type: 'warning',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}
				let param = {
					iccids: iccids
				};
				this.$confirm(
					'确认要更新流量卡信息吗？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false,
						type: 'warning'
					}
				).then(_ => {
					// loading
					this.loading = this.$loading({
						lock: true,
						text: '正在查询流量卡信息...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$request.postJsonRequest(ApiGpsTag.updateSimApi, param).then(result => {
						if(result.code == 0) {
							this.$message({
								message: '流量卡更新成功',
								type: 'success',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
							this.searchGpsTag();
							this.loading.close();
						}
					}).catch(error => {
						this.$message({
							message: "流量卡更新异常：" + this.$request.error.msg,
							type: 'warning',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
						this.loading.close();
					})
				});
			},

			/**
			 * @Description
			 * @Param 查询登录账户的项目
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			searchAccountProject() {
				return false;
				this.$request.postJsonRequest(ApiOrg.findLoginProjectApi, {}).then(result => {
					this.projectInfos = Object.assign({}, {});
					if(result.code == 0) {
						result.data.forEach((row, index) => {
							let projectId = row.projectId;
							this.projectInfos[projectId] = row;
						})
						// this.searchOrg();
					}
				}).catch(error => {
					console.log("查询登录项目异常：" + this.$request.error.msg);
				})
			}, // searchAccountProject

			/**
			 * @Description
			 * @Param 查询gps标签
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			searchGpsTag() {
				let loading = this.$loading({
					lock: true,
					text: '数据加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.filters.keyword = this.filters.keyword.trim();
				if(this.filters.accountKey == '') {
					this.filters.accountKey = this.getFirstKeyValue();
				}
				this.$request.postJsonRequest(ApiGpsTag.searchGpsTagApi, {
					// projectId: this.filters.projectId,
					allocateType: this.filters.allocateType, // 0未分配 1已分配
					key: (this.filters.allocateType == 1 ? this.filters.accountKey : ''),
					keyword: this.filters.keyword,
					status: this.filters.status,
					bindType: this.filters.bindType, // 0未绑定 1已绑定
					type: this.filters.type,
					simExpirationTime: this.filters.simExpirationTime,
					orderBy: this.filters.orderBy,
					total: this.pagination.total,
					startNum: this.pagination.startNum,
					limit: this.pagination.limit,
				}).then(result => {
					// console.log(result)
					loading.close();
					this.tagInfos = [];
					// 总数
					this.pagination.total = result.total;
					if(result.total > 0) {
						result.rows.forEach((row, index) => {
							if(this.projectInfos.hasOwnProperty(row.projectId)) {
								row.projectName = this.projectInfos[row.projectId].projectName;
							}
							if(this.accountManagerInfos.hasOwnProperty(row.key)) {
								row.account = this.accountManagerInfos[row.key].account;
							}
							this.tagInfos.push(row);
						});
					}
				}).catch(error => {
					loading.close();
					console.log("查询标签异常：" + this.$request.error.msg);
				})
			},
			/**
			 * @Description
			 * @Param 是否选择
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			checkSelectable(row) {
				return true;
			},
			/**
			 * @Description
			 * @Param 重新搜索
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			researchGpsTag() {
				this.pagination.total = 0;
				this.pagination.startNum = 0;
				this.pagination.currentPage = 1;
				this.searchGpsTag();
			},
			/**
			 * @Description
			 * @Param 改变排序
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			changeSort(data) {
				let prop = data.prop;
				let order = data.order;
				if(order == null) {
					order = this.filters.orderBy[prop];
				} else {
					order = order.replace("ending", "");
				}
				if(order == null) {
					this.filters.orderBy["sid"] = "asc";
				} else {
					this.filters.orderBy = {};
					this.filters.orderBy[prop] = order;
				}
				this.researchGpsTag();
			},
			/**
			 * @Description
			 * @Param 当前页数据改变
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			handleCurrentChangeSub(val) {
				this.pagination.currentPage = val;
				this.pagination.startNum = this.pagination.limit * (val - 1);
				this.searchGpsTag();
			},
			/**
			 * @Description
			 * @Param 页长度改变
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			handleSizeChangeSub(val) {
				this.pagination.limit = val;
				this.pagination.currentPage = 1;
				this.pagination.startNum = 0;
				this.searchGpsTag();
			},

			/**
			 * 添加基站
			 */
			add() {
				// loading
				this.loading = this.$loading({
					lock: true,
					text: '正在查询未加入项目的标签...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$request.postJsonRequest(ApiGpsTag.searchUnAddGpsTagApi, {
					limit: this.limit,
					orderBy: {
						status: "asc",
						did: "asc"
					}
				}).then(result => {
					this.loading.close();
					this.upload.previewTitle = [];
					this.upload.previewData = [];
					/*
					if(result.data.length == 0) {
						this.$message({
							message: '未找到新增的标签',
							type: 'info',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
						return;
					}
					*/
					if(result.code == 0 && result.data) {
						// 显示基站列表信息
						this.upload.previewTitle.push({
							label: '设备编号',
							prop: 'did',
						});
						this.upload.previewTitle.push({
							label: '流量卡号',
							prop: 'iccid',
						});
						this.upload.previewTitle.push({
							label: '设备状态',
							prop: 'statusName',
						});
						this.upload.previewTitle.push({
							label: '软件版本',
							prop: 'versionSoft',
						});
						this.upload.previewTitle.push({
							label: '硬件版本',
							prop: 'versionHard',
						});
						this.upload.previewTitle.push({
							label: '电量',
							prop: 'power',
						});
						// this.upload.previewTitle.push({
						//     label: '状态',
						//     prop: 'statusName',
						// });
						this.upload.previewTitle.push({
							label: '更新时间',
							prop: 'uploadTime',
						});
						result.data.forEach((row, index) => {
							let _row = {
								did: row.did,
								id: row.did,
								iccid: row.iccid,
								versionSoft: row.versionSoft,
								versionHard: row.versionHard,
								power: row.power + '%',
								statusName: this.status[row.status],
								uploadTime: this.$moment(row.uploadTime).format('YYYY-MM-DD HH:mm:ss'),
								disabled: false,
								checked: false,
							}
							
							let _row_ = {};
							for(let i in _row) {
								// 外围添加 span
								_row_[i + 'Span'] = this.surroundSpan(_row[i] == null ? "" : _row[i]);
							};

							this.upload.previewData.push(Object.assign({}, _row, _row_));
						});
						//弹出预览
						this.$refs.gpsTagAddDialog.openDialog("分配标签", "确定分配");
					} else {
						this.$message({
							message: result.msg,
							type: 'error',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
					}
				}).catch(error => {
					console.log("查询未加入的标签异常：" + this.$request.error.msg);
				})
			},

			/**
			 * @Description
			 * @Param 批量回收
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			deleteRows() {
				let selection = this.$refs.multipleTable.selection;
				if(selection.length == 0) {
					this.$message({
						message: '请选择要回收的数据',
						type: 'info',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}
				this.$confirm(
					'确认批量回收选中的设备吗？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false,
						type: 'warning'
					}
				).then(_ => {
					let dids = [];
					selection.forEach((row, index) => {
						dids.push(row.did);
					})
					let param = {
						dids: dids
					};
					this.delete(param);
				});

			}, // deleteRows
			/**
			 * @Description
			 * @Param 回收gps标签
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			delete(param) {
				if(this.locked) return;
				this.locked = true;
				this.$request.postJsonRequest(ApiGpsTag.deleteGpsTagApi, param).then(result => {
					// console.log(result.code);
					if(result.code == 0) {
						this.$message({
							message: '回收成功',
							type: 'success',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
					} else {
						this.$message({
							message: result.msg,
							type: 'error',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
					}
					this.locked = false;
					this.searchGpsTag();
				}).catch(error => {
					console.log("回收GPS标签异常：" + this.$request.error.msg);
					this.locked = false;
				})
			}, // delete

			/**
			 * @Des 数据删除
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			completelyDelete() {
				let selection = this.$refs.multipleTable.selection;
				if(selection.length == 0) {
					this.$message({
						message: '请选择数据',
						type: 'info',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}
				this.$confirm(
					'确认批量删除选中的信息吗？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false,
						type: 'warning'
					}
				).then(_ => {
					let dids = [];
					selection.forEach((row, index) => {
						dids.push(row.did);
					})
					this.operationLock = true;
					this.$request.postJsonRequest(ApiGpsTag.completelyDeleteApi, {
						dids: dids,
					}).then(result => {
						if(result.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
							// this.handleDialogClose();
							this.researchGpsTag();
						} else {
							this.$message({
								message: result.msg,
								type: 'error',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
						}
						this.operationLock = false;
					}).catch(error => {
						console.log("删除GPS标签异常：" + this.$request.error.msg);
						this.operationLock = false;
					});
				});
			}, // completelyDelete

			/**
			 * @Description
			 * @Param 修改基站配置
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			editRowConfig(row, index) {
				// console.log(row, index);
				this.$refs.gpsTagConfigDialog.openDialog(row, index);
			},
			/**
			 * @Description
			 * @Param 设置基站配置
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			/*setRow(row, index){
			    // console.log(row, index);
			    setTimeout(()=>{
			        this.$set(this.tagInfos, index, row);
			    },1000);
			},*/
			/**
			 * @Description
			 * @Param 处理行
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			rowHandle(row) {
				if(row.checked) {
					row.checked = false;
				} else {
					row.checked = true;
				}
				this.$refs.multipleTable.toggleRowSelection(row, row.checked)
			},

			/**
			 * @Des 查询导出数据
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			searchExportData() {
				this.$confirm(
					'确认要导出查询的所有设备信息？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false,
						type: 'warning'
					}
				).then(_ => {
					// loading
					this.loading = this.$loading({
						lock: true,
						text: '正在查询设备信息...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$request.postJsonRequest(ApiGpsTag.searchGpsTagApi, {
						// projectId: this.filters.projectId,
						key: this.filters.key,
						keyword: this.filters.keyword.toUpperCase().trim(),
						status: this.filters.status,
						type: this.filters.type,
						simExpirationTime: this.filters.simExpirationTime,
						orderBy: this.filters.orderBy,
						total: 0,
						startNum: 0,
						limit: 0,
					}).then(result => {
						this.exportDatas = Object.assign([], []);
						if(result.total > 0) {
							// console.log(result.rows)
							result.rows.forEach((row, index) => {
								if(this.projectInfos.hasOwnProperty(row.projectId)) {
									row.projectName = this.projectInfos[row.projectId].projectName;
									row.hasArea = this.projectInfos[row.projectId].hasArea;
								}
								if(this.accountManagerInfos.hasOwnProperty(row.key)) {
									row.account = this.accountManagerInfos[row.key].account;
								}
								this.exportDatas.push(row);
							});
						}
						this.$nextTick(() => {
							GlobalFun.exportExcel(document.querySelector("#out-table"), 'GPS标签信息.xlsx');
							this.loading.close();
						})
					}).catch(error => {
						this.loading.close();
						console.log("导出GPS标签异常：" + ApiGpsTag.searchGpsTagApi);
					})
				});
			},

			/**
			 * @Des 上传之前的处理
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			beforeUpload(file) {
				// 上传之前
				// console.log(file)
				this.upload.previewTitle = Object.assign([], []);
				this.upload.previewData = Object.assign([], []);
				let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
				let size = file.size / 1024 / 1024;
				// console.log(extension, size)
				if(extension !== 'xlsx') {
					this.$message.warning('只能上传后缀是.xlsx的文件');
				}
				if(size > 10) {
					this.$message.warning('文件大小不得超过10M');
				}
			},

			/**
			 * @Des 上传成功后的处理
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			uploadGpsTagIdSuccess(res, file, fileList) {
				// 上传成功
				// console.log(res, file, fileList);
				// console.log(this.upload.fileType)
				if(res.code == 0) {
					// 返回数据
					// console.log(res.data)
					// 显示标签列表信息
					this.upload.previewTitle.push({
						label: '标签编号',
						prop: 'did',
					});
					this.upload.previewTitle.push({
						label: '序列号',
						prop: 'sid',
					});
					this.upload.previewTitle.push({
						label: '信息',
						prop: 'message',
					});
					res.data.forEach((row, index) => {
						let addCell = {
							did: row.did,
							id: row.sid,
							disabled: row.code == 0 ? false : true,
							checked: row.code == 0 ? true : false,
						}
						let _row = Object.assign({}, row, addCell);

						let _row_ = {};
						for(let i in _row) {
							// 外围添加 span
							_row_[i + 'Span'] = this.surroundSpan(_row[i] == null ? "" : _row[i]);
						};

						this.upload.previewData.push(Object.assign({}, _row, _row_));
					})

					this.upload.showSerialNumber = true;
					this.upload.saveUrl = this.uploadGpsTagId.saveUrl;
					//弹出预览
					this.$refs.gpsTagUploadDialog.openDialog("GPS标签编号上传修改预览", "确定上传", 1);
					// console.log(res.data)
				} else {
					this.$message({
						type: 'error',
						message: res.msg,
						dangerouslyUseHTMLString: true
					});
				}
			},

			/**
			 * @Description
			 * @Param 上传失败后的处理
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			uploadError(err, file, fileList) {
				// 上传失败
				this.$message({
					type: 'error',
					message: err.msg,
					dangerouslyUseHTMLString: true
				});
			},

			logDetail(row, index) {
				this.$refs.gpsTagLogTable.openDialog('设备【' + row.did + '】日志', row, index);
			},

			searchSim(row, index) {
				this.$emit('switchTab', 1, GlobalFun.OptType.SEARCH, row.iccid);
			},

			/**
			 * 添加SIM卡
			 * @param row
			 * @param index
			 */
			addSim(row, index) {
				// console.log(row, index);
				this.$refs.gpsTagSimConfigDialog.openDialog(row, index, true);
			},

			addNotice() {
				let selection = this.$refs.multipleTable.selection;
				if(selection.length == 0) {
					this.$message({
						message: '请选择要添加消息的' + this.types["02"] + '设备',
						type: 'info',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}
				let dids = [];
				selection.forEach((row, index) => {
					if(row.type == '02') {
						dids.push(row.did);
					}
				})
				let param = {
					dids: dids
				};
				if(dids.length == 0) {
					this.$message({
						message: '请选择要添加消息的' + this.types["02"] + '设备',
						type: 'info',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}
				this.$refs.gpsTagNoticeAddDialog.openDialog({
					dids: dids
				})
			}

		}
	}
</script>

/* CSS */
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagTable.vue